import React, { Component } from 'react';
import _ from 'lodash';

import Table from 'components/table/Table';


class SortableTable extends Component {

  constructor(props) {
    super(props);
    this.state = {
      columns: this.props.columns
    };
  }

  createDataArray = (data, columns) => {
    columns = _.reject(columns, (column) => !column.sortable);
    columns = _.orderBy(columns, ['sortOrder'], ['asc']);
    const sortColumns = _.map(columns, (column) => column.sortFunction || column.key);
    const sortDirections = _.map(columns, (column) => column.sortDirection);

    // regardless of sort order bubble up completely blank rows to the top
    sortColumns.unshift((item) => {
      if (item.name) {
        return 0;
      }
      return 1;
    });
    sortDirections.unshift('desc');

    data = _.orderBy(data, sortColumns, sortDirections);
    data.unshift({row: 'header'});

    return data;
  }

  onHeaderClick = (column) => {
    const columns = _.cloneDeep(this.state.columns);
    const sortableColumns =  _.reject(columns, (column) => !column.sortable);
    const currentSortedColumn = _.find(sortableColumns, {sortOrder: 1});
    if(currentSortedColumn.key === column.key) {
      // reverse sort
      currentSortedColumn.sortDirection = currentSortedColumn.sortDirection === 'asc' ? 'desc' : 'asc';
    } else {
      const newSortedColumn = _.find(columns, {key: column.key});
      newSortedColumn.sortOrder = 0;
      _.each(_.orderBy(columns, ['sortOrder'], ['asc']), (column, index) => {
        column.sortOrder = index + 1;
      });
    }

    this.setState({columns});
  }

  render() {
    const data = this.createDataArray(this.props.data, this.state.columns);
    const getCellLines = (index) => this.props.getCellLines(index, data);
    return (
      <Table
        data={data}
        columns={this.state.columns}
        getCellLines={getCellLines}
        meet={this.props.meet}
        onHeaderClick={this.onHeaderClick}
        numberOfFixedLeftColumns={this.props.numberOfFixedLeftColumns}
        media={this.props.media}
        padBottom
      />
    );
  }
}

export default SortableTable;
